import React, { useState } from "react"
import { ShadowRoot } from "./ShadowRoot"
import { getIconType, getStandardIcon, getSVGIcon } from "./constants/utils"

export const CollapsibleListItem = ({ title, openStatus, content, contentType, index, openIcon, closeIcon, onClickCallback, extra, data }) => {
  const showParentBorder= extra?.collapsible_list_border_style !== "none";
  const itemStyle = {
    borderColor: extra?.meta_field_border_color
  };
  if (showParentBorder) {
    const isFirst= index === 0;
    const isLast= index === data.length - 1;  
    itemStyle.borderColor = extra?.collapsible_list_line_color;
    if (isFirst) {
      itemStyle.borderTop = "none";
    }
    if (isLast) {
      itemStyle.borderBottom = 'none';
    }
  }

  return <div>
      <details class="collapsible-list-item" open={openStatus} onClick={(event) => {
        if (event.target.tagName === "DIV") {
          return
        }
        onClickCallback(index, event.currentTarget.open)
      }}>
        <summary style={{backgroundColor: extra?.meta_field_bg_color, ...itemStyle}} class={`collapsible-list-item-title ${index === 0 ? "collapsible-list-first-item-title" : ""}`} data-accordion-index={index} tabindex={index} aria-expanded="false" aria-controls={title}>
          <span>
            <h3 style={{ color: extra?.meta_field_text_color}}>{title}</h3>
          </span>
          <span class="collapsible-list-item-title-icon" style={{ color: extra?.collapsible_list_icon_color}}>
            <span class="collapsible-list-opened">{ getIconType(openIcon) === 'svg' ? <img className="m-0" height={"30px"} width={'auto'} src={getSVGIcon(openIcon)} /> : <i aria-hidden="true" class={getStandardIcon(openIcon) || "fa-plus fas"}></i> }</span>
            <span class="collapsible-list-closed">{  getIconType(closeIcon) === 'svg' ? <img className="m-0" height={"30px"} width={'auto'} src={getSVGIcon(closeIcon)} /> : <i aria-hidden="true" class={getStandardIcon(closeIcon) || "fa-minus fas"}></i> }</span>
          </span>
        </summary>
        <div aria-labelledby={title} class="collapsible-list-content" style={{color: contentType !== "RICH_TEXT" && extra?.meta_field_body_text_color, backgroundColor: extra?.meta_field_body_bg_color, ...itemStyle}}>
          {
            contentType === "RICH_TEXT" ? <ShadowRoot><div dangerouslySetInnerHTML={{ __html: content }} ></div></ShadowRoot> : content
          }
        </div>
      </details>
  </div>
}

const CollapsibleList = ({ data, openIcon, closeIcon, autoToggle, extra }) => {
    const [collapsibleListMap, setCollapsibleListMap] = useState({
      0: true
    })
    const setCollapsibleListData = (index, open) => {
      const listObj = { ...collapsibleListMap };
      if (autoToggle) {
        for (let i in listObj) {
          listObj[i] = ""
        }
      }
      listObj[index] = open
      setCollapsibleListMap({
        ...listObj
      })
    }
    const borderStyle = extra?.collapsible_list_border_style !== "none" ? { border: `1px solid ${extra?.meta_field_border_color}`, borderRadius: extra?.collapsible_list_border_style } : {}
    
    return <div style={borderStyle}>
      {
        data.map((item, itemIndex) => {
          return <CollapsibleListItem extra={extra} data={data} onClickCallback={setCollapsibleListData} openIcon={openIcon} closeIcon={closeIcon} title={item.name} content={item.value} contentType={item.valueType} index={itemIndex} openStatus={collapsibleListMap[itemIndex]} />
        })
      }
    </div>;
}

export default CollapsibleList;
